<template>
  <v-content>
    <v-navigation-drawer
      touchless
      stateless
      :value="drawer"
      :width="drawerWidth()"
      fixed
      app
    >
      <template v-slot:prepend>
        <v-row class="mr-1 ml-1">
          <v-col cols="5">
            <theme-switcher-app />
            <language-picker />
          </v-col>
          <v-col
            cols="7"
            style="text-align: right; line-height: 30px; font-size: 12px;"
          >
            <a
              target="_blank"
              href="mailto:demat@novacel-optical.com"
              style="max-width: 100px;"
            >{{ $t('login.needHelp') }}</a>
          </v-col>
        </v-row>
      </template>
      <v-row
        justify="center"
        align-content="center"
      >
        <v-col
          md="9"
          cols="11"
        >
          <welcome-card />
        </v-col>
        <v-col
          md="9"
          cols="11"
        >
          <login-card />
        </v-col>
      </v-row>
      <template v-slot:append>
        <v-row class="mr-1 ml-1">
          <v-col cols="1">
            v{{ version }}
          </v-col>
          <v-col cols="2">
            <v-icon
              small
              color="primary"
              class="ml-2"
              @click="$store.dispatch('setModalPrivacy', true)"
            >
              fas fa-info-circle
            </v-icon>
          </v-col>
          <v-col
            cols="9"
            style="text-align: right;"
          >
            <a @click="openSite">Novacel-Optical</a> &copy; {{ new Date().getFullYear() }}
          </v-col>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-container
      v-if="!$mobileDetect.phone()"
      fluid
      fill-height
      class="d-flex justify-center align-center"
    >
      <div class="video-wrapper">
        <iframe
          src="https://www.youtube.com/embed/BlhWU-Go1ww?si=YfpHI6KkGmg1p-St"
          title="Retrouvez facilement vos factures électroniques Novacel (Réforme 2026)"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </v-container>
  </v-content>
</template>
<script>
  export default {
    name: 'Login',
    components: {
      LanguagePicker: () => import('../components/Login/LanguagePicker'),
      WelcomeCard: () => import('../components/Login/WelcomeCard'),
      LoginCard: () => import('../components/Login/LoginCard'),
      ThemeSwitcherApp: () => import('../components/App/ThemeSwitcherApp'),
    },
    data () {
      return {
        version: process.env.VUE_APP_VERSION,
      }
    },
    computed: {
      drawer () {
        return !this.$store.state.loader.show
      },
      showPrivacyLink: {
        get () {
          return !this.$store.state.privacy
        },
      },
    },
    mounted () {
      this.$store.dispatch('checkApiAccess')
    },
    methods: {
      openSite () {
        let adress = 'https://www.novacel-optical.com/'
        if (this.$i18n.locale === 'de') adress = 'https://www.novacel-optical.de/'
        window.open(adress, '_blank')
      },
      drawerWidth () {
        if (this.$mobileDetect.phone()) {
          return window.innerWidth
        } else {
          return 450
        }
      },
    },
  }
</script>

<style scoped>
a {
  text-decoration: none;
  text-align: right;
}

.video-wrapper {
  position: relative;
  width: 100%;
  max-width: 900px;
  padding-bottom: 50%;
  height: 0;
}
.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
